import React from "react";
import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip } from "reactstrap";

const BackOffice = ({ path }) => {
  let location = useLocation()
  const [color, setColor] = React.useState(color);

  React.useEffect(
    () => {
      const newColor = window.location.pathname.includes(path) ? "primary" : "secondary";
      setColor(newColor)
    }, [location]);

  return (
    <Can
      roles={[roles.ADMIN]}
      yes={() => {

        return (

          <UncontrolledDropdown className="ml-1 mt-1">

            <DropdownToggle color={color} id="bofficeNavBtn" caret>
              <FontAwesomeIcon icon="archive" /><span className="d-none d-xl-block">Backoffice</span>
            </DropdownToggle>

            <UncontrolledTooltip placement="auto" popperClassName="tooltip-primary" target="bofficeNavBtn">Backoffice
            </UncontrolledTooltip>

            <DropdownMenu>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/devices`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="mobile-alt" className="mr-1" /> Elenco Dispositivi
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/import-devices`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <i className="pi pi-download mr-1"></i> Importa Dispositivi
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/add-device`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="plus-circle" className="mr-1" /> Aggiungi Dispositivo
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/gis-devices`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="map-marked-alt" className="mr-1" /> Controllo Dispositivi GIS
              </DropdownItem>

              <div className="divider my-2"></div>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/simcards`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="sim-card" className="mr-1" /> Elenco SIM
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/import-simcards`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <i className="pi pi-download mr-1"></i> Importa SIM
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/add-sim`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="plus-circle" className="mr-1" /> Aggiungi SIM
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/devicepairing`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="link" className="mr-1" /> Associa Dispositivi/SIM
              </DropdownItem>

              <div className="divider my-2"></div>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/storage`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="warehouse" className="mr-1" /> Magazzino Generale
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/orders`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="truck" className="mr-1" /> Gestione Ordini
              </DropdownItem>

              <div className="divider my-2"></div>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/vehicles`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="car" className="mr-1" /> Elenco Veicoli
              </DropdownItem>

              <DropdownItem
                tag={RouterNavLink}
                to={`${path}/customers`}
                className="dropdown-profile"
                activeClassName="router-link-exact-active-nav"
              >
                <FontAwesomeIcon icon="users" className="mr-1" /> Elenco Clienti
            </DropdownItem>

            </DropdownMenu>

          </UncontrolledDropdown>
        )
      }}
      no={() => null}
    />
  )
};

export default BackOffice;
